const talentAppUrl = process.env.REACT_APP_ENV === 'production'
  ? 'https://thungela-talent.web.app/employees'
  : 'https://thungela-talent-beta.web.app/employees'

export const DEFAULT_BULK_EMAIL_SUBJECT = 'REMINDER | Update your talent profile and career objectives'

export const DEFAULT_BULK_EMAIL_BODY = `Dear colleagues,

We encourage you to complete your online talent profile and career objectives to help better understand your career journey, experiences, mobility preferences, and aspirations.

Your talent profile serves as your internal CV, offering a comprehensive view of your professional background – both internally and externally. This information supports more meaningful development and career conversations between you, your manager, and your Manager Once Removed (MoR).

Please ensure your profile is completed and up to date by Friday, 12 December 2025.

To access your talent profile, click here: ${talentAppUrl}

For assistance or support, please reach out to Shene Prinsloo (shene.prinsloo@thungela.com) or Thandi Mathebula (thandi.mathebula@thungela.com).

Thank you for taking the time to invest in your career development.

Kind regards,
Talent Management team`
